export const LOAD_OPENING_HOURS = 'LOAD_OPENING_HOURS'
export const LOAD_OPENING_HOURS_SUCCESS = 'LOAD_OPENING_HOURS_SUCCESS'
export const LOAD_OPENING_HOURS_FAILED = 'LOAD_OPENING_HOURS_FAILED'

export const UPDATE_OPENING_HOURS = 'UPDATE_OPENING_HOURS'
export const UPDATE_OPENING_HOURS_SUCCESS = 'UPDATE_OPENING_HOURS_SUCCESS'
export const UPDATE_OPENING_HOURS_FAILED = 'UPDATE_OPENING_HOURS_FAILED'
